import React, { FC, PropsWithChildren } from 'react';
import { styled } from 'linaria/react';
const ModalWrapper: FC<PropsWithChildren> = ({
  children
}) => <ModalContentWrapper>{children}</ModalContentWrapper>;
export default ModalWrapper;
const ModalContentWrapper = /*#__PURE__*/styled('div')({
  name: "ModalContentWrapper",
  class: "m18k6ant",
  propsAsIs: false
});

require("./ModalWrapper.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ModalWrapper.tsx");